import { ref, onMounted, getCurrentInstance } from 'vue';
import { getListFieldApprovalKTT, getListApprovalKTT, approveIDPByKTT, rejectIDPByKTT } from './api';

export function useApprovalKTT() {
  const instance = getCurrentInstance();
  const swal = instance?.proxy?.$swal;
  const trainings = ref([]);
  const employees = ref([]);
  const pagination = ref({
    totalItems: 0,
    page: 1,
    limit: 10,
    totalPages: 1,
  });
  const loading = ref(false);
  const actionLoading = ref(false);
  const error = ref(null);

  // Get token from URL query parameter (Vue 2 compatible)
  const token = instance?.proxy.$route?.query?.token;

  // // Fetch training fields (columns)
  // async function fetchTrainingFields() {
  //   if (!token) {
  //     error.value = 'Token tidak ditemukan di URL';
  //     return;
  //   }

  //   try {
  //     loading.value = true;
  //     const response = await getListApprovalKTT({ token });

  //     if (response.httpCode === 200 && response.data) {
  //       trainings.value = response.data.map(item => ({
  //         id: item.id,
  //         title: item.title
  //       }));
  //     }
  //   } catch (err) {
  //     error.value = 'Gagal memuat data training';
  //     console.error(err);
  //   } finally {
  //     loading.value = false;
  //   }
  // }

  // Fetch employee approval data
  async function fetchEmployeeData(params = {}) {
    if (!token) {
      error.value = 'Token tidak ditemukan di URL';
      return;
    }

    try {
      loading.value = true;
      const page = params.page || pagination.value.page || 1;
      const limit = params.limit || pagination.value.limit || 10;
      const response = await getListApprovalKTT({ token, page, limit });

      if (response.httpCode === 200 && response.data) {
        employees.value = response.data.data || [];
        pagination.value = {
          totalItems: response.data.totalItems || 0,
          page: response.data.page || page,
          limit: response.data.limit || limit,
          totalPages: response.data.totalPages || 1,
        };
      }
    } catch (err) {
      error.value = 'Gagal memuat data karyawan';
      console.error(err);
    } finally {
      loading.value = false;
    }
  }

  async function fetchAllEmployeeData() {
    if (!token) {
      error.value = 'Token tidak ditemukan di URL';
      return [];
    }

    const response = await getListApprovalKTT({
      token,
      page: 1,
      limit: pagination.value.limit || 10,
      all: true,
    });

    if (response?.httpCode === 200 && response.data) {
      return response.data.data || [];
    }

    return [];
  }

  // Update status per employee per training
  function updateStatus(empId, trainingId, newStatus) {
    const emp = employees.value.find(e => e.id === empId);
    if (emp) {
      if (!emp.status) emp.status = {};
      emp.status[trainingId] = newStatus;
    }
  }

  // Handle approve selected IDP submissions
  async function handleApproveAPI(ids = []) {
    try {
      actionLoading.value = true;
      const response = await approveIDPByKTT({ token, ids });

      if (response && response.httpCode === 200) {
        // Refresh data
        await fetchEmployeeData({
          page: pagination.value.page,
          limit: pagination.value.limit,
        });
        swal?.('Success', 'Pengajuan IDP berhasil disetujui.', 'success');
        return true;
      } else {
        swal?.('Error', 'Pengajuan IDP belum berhasil disetujui', 'error');
        return false;
      }
    } catch (err) {
      console.error('Error approving IDP:', err);
      swal?.('Error', 'Terjadi kesalahan saat menyetujui pengajuan IDP', 'error');
      return false;
    } finally {
      actionLoading.value = false;
    }
  }

  // Handle reject selected IDP submissions with reason
  async function handleRejectAPI(reason, ids = []) {
    try {
      actionLoading.value = true;
      const response = await rejectIDPByKTT({
        token,
        reason,
        ids,
      });

      if (response && response.httpCode === 200) {
        // Refresh data
        await fetchEmployeeData({
          page: pagination.value.page,
          limit: pagination.value.limit,
        });
        swal?.('Success', 'Pengajuan IDP berhasil ditolak.', 'success');
        return true;
      } else {
        swal?.('Error', 'Pengajuan IDP belum berhasil ditolak', 'error');
        return false;
      }
    } catch (err) {
      console.error('Error rejecting IDP:', err);
      swal?.('Error', 'Terjadi kesalahan saat menolak pengajuan IDP', 'error');
      return false;
    } finally {
      actionLoading.value = false;
    }
  }

  // Initialize data on mount
  onMounted(async () => {
    // await fetchTrainingFields();
    await fetchEmployeeData();
  });

  return {
    employees,
    trainings,
    pagination,
    loading,
    actionLoading,
    error,
    updateStatus,
    token,
    fetchEmployeeData,
    fetchAllEmployeeData,
    handleApproveAPI,
    handleRejectAPI,
  };
}
